import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { isDirty } from 'redux-form';
import AiAgentPreferencesView from '../../../../components/Administration/SettingsPage/AiAgent/AiAgentPreferences/aiAgentPreferencesView';
import { jsxActions as AiAgentPreferencesViewActions } from '../../../../actions/Administration/SettingsPage/aiAgentPreferencesViewActions';
import {jsxActions as settingsPageActions} from '../../../../actions/Administration/SettingsPage/settingsPageActions';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(AiAgentPreferencesViewActions, dispatch),
      settingsPageActions : bindActionCreators(settingsPageActions, dispatch),
    }
  }
}

const AiAgentPreferencesViewContainer = connect(
  (state) => {
    return {
      sData: state.administration.getIn(['settingsPage', 'aiAgentPreferencesView']),
      isDirty: isDirty('aiAgentPreferencesView')(state),
    };
  },

  mapDispatchToProps
)(AiAgentPreferencesView);

export default AiAgentPreferencesViewContainer;
